import { CampaignProps } from '@commons/types'
import { viewPromotion } from '@content/helpers/src/gtmEvents'
import { viewportEvent } from '@content/helpers/src/viewPortEvent'
import { useEffect, useRef } from 'preact/hooks'

const useImpressionTracker = (
    containerRef,
    campaign,
    shouldExecute = true
): {
    containerRef: HTMLElement
    campaign: CampaignProps
    shouldExecute: boolean
} => {
    const hasTrackedRef = useRef(false)

    useEffect(() => {
        if (
            !shouldExecute ||
            hasTrackedRef.current ||
            !containerRef.current ||
            !campaign
        ) {
            return
        }

        const uniqueKey = `view_promotion_${Math.random().toString(36).substr(2, 9)}`

        const observer = viewportEvent(
            containerRef.current,
            () => {
                if (!hasTrackedRef.current) {
                    viewPromotion({ ...campaign })
                    hasTrackedRef.current = true
                }
            },
            { once: true, uniqueKey }
        )
        return () => {
            observer.disconnect()
        }
    }, [campaign])

    return containerRef
}

export default useImpressionTracker
